module.exports = __webpack_public_path__ + "img/icon-alert-medium-full.bcb368fc.svg";